<template>
    <div>
        <div v-for="flag in filteredFlags" :key="flag.field_key">
            <div class="add-contact-wrapper" v-if="flags.find(f => f.field_key === flag.field_key).showField">
                <button v-b-tooltip.hover :title="`Add ${flag.label}`"
                    class="add-contact-button exclude-outside-click d-inline-block"
                    @click="showAddCfContact(flag.field_key)">
                    {{ flag.label }}
                </button>
                <plus-button :title="`Add ${flag.label}`" @click="showAddCfContact(flag.field_key)"></plus-button>
                <div class="custom-multiselect" v-show="flags.find(f => f.field_key === flag.field_key)
            .toggleContactSelect
            " v-click-outside="outside">
                    <autocomplete :debounce-time="500" class="multiselect" :search="onCfContactSearch"
                        @submit="onCfContactSelect" placeholder="Start typing to select contact"
                        aria-label="Start typing to select contact" :ref="`search-${flag.field_key}`" auto-select>
                        <template v-slot:result="{ result, props }">
                            <li v-bind="props" class="autocomplete-result contact-result multiselect__element"
                                v-if="result.id == null">
                                <div class="option_add" v-html="result.label"></div>
                            </li>
                            <li v-bind="props" class="autocomplete-result contact-result multiselect__element"
                                v-if="result.id">
                                <div class="option__desc">
                                    <div class="option__name exclude-outside-click">
                                        {{ result.first_name }}
                                        {{ result.last_name }}
                                    </div>
                                    <div class="option__company exclude-outside-click">
                                        {{ result.company_name }}
                                    </div>
                                    <div class="option__phone exclude-outside-click">
                                        {{ result.phone }}
                                    </div>
                                </div>
                            </li>
                        </template>
                    </autocomplete>
                </div>
                <div class="contact-box" v-for="(contact, index) in _.filter(filteredContactList, {
            field_key: flag.field_key
        })" :key="`${flag.field_key}-${index}`" v-if="contact.value && contact.contactData">
                    <div class="contact-box__name">
                        {{ contact.contactData.name }}
                        <a v-if="!(
                        !userAbilities.editMediaCall ||
                        projectDetail.permissions.viewOnly)" 
                        v-b-tooltip.hover 
                        :title="`Edit ${flag.label}`" 
                        class="edit-contact-btn" 
                        href="#" @click.prevent="
                        updateCfContact(
                            contact.contactData,
                            contact.children,
                            flag.field_key
                        )">
                            <i class="fas fa-edit"></i>
                        </a>
                    </div>
                    <div v-if="contact.contactData.position" class="contact-box__position">
                        {{ contact.contactData.position }}
                    </div>
                    <div v-if="contact.children" v-for="(child, i) in contact.children" :key="`${child.slug}-${i}`"
                        class="contact-box__position">
                        {{ child.name }}
                    </div>
                    <div v-if="contact.contactData.company_name" class="contact-box__company_name">
                        {{ contact.contactData.company_name }}
                    </div>
                    <div v-if="contact.contactData.phone" class="contact-box__phone">
                        <a :href="Format.hrefPhone(contact.contactData.phone)">
                            T: {{ contact.contactData.phone }}</a>
                    </div>
                    <div v-if="contact.contactData.cell_phone" class="contact-box__cell_phone">
                        <a :href="Format.hrefPhone(contact.contactData.cell_phone)">
                            M: {{ contact.contactData.cell_phone }}</a>
                    </div>
                    <div v-if="contact.contactData.fax_number" class="contact-box__fax">
                        F:{{ contact.contactData.fax_number }}
                    </div>
                    <div v-if="contact.contactData.email_address" class="contact-box__email">
                        <a :href="Format.hrefEmail(contact.contactData.email_address)">
                        {{ contact.contactData.email_address }}</a>
                    </div>
                    <div v-if="contact.contactData.website" class="contact-box__website">
                        <a :href="Format.website(contact.contactData.website)">{{ contact.contactData.website }}</a>
                    </div>
                    <div v-if="contact.contactData.address" class="contact-box__address">
                        {{ contact.contactData.address }}
                    </div>
                    <div v-if="contact.contactData.city" class="contact-box__city">
                        {{ Format.city(contact.contactData.city) }}
                    </div>
                    <div v-if="contact.contactData.province" class="contact-box__province">
                        {{ contact.contactData.province }}
                    </div>
                    <div v-if="contact.contactData.country_id" class="contact-box__country_id">
                        {{ contact.contactData.country_id }}
                    </div>
                    <div v-if="contact.contactData.postal_code" class="contact-box__postal_code">
                        {{ Format.postalCode(contact.contactData.postal_code) }}
                    </div>
                    <div v-if="contact.contactData.region" class="contact-box__region">
                        {{ contact.contactData.region }}
                    </div>
                    <div v-if="contact.contactData.notes" class="contact-box__notes">
                        {{ contact.contactData.notes }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Format from "../../utility/Format";
import Autocomplete from "@trevoreyre/autocomplete-vue";

export default {
    data() {
        return {
            Format,
            currentFieldKey: "",
            flags: []
        };
    },
    components: {
        Autocomplete
    },
    props: [
        "projectDetail"
    ],
    computed: {
        ...mapGetters([
            "deliverableContactsLabel",
            "userAbilities"
        ]),
        // so that we can use lodash in the template
        _() {
            return _;
        },
        filteredFlags() {
            return this.flags;
        },
        filteredContactList() {
            const childObjArray = this.projectDetail.customFields.filter(
                item => item.parent_id != null
            );
            const cfArray = this.projectDetail.customFields;
            cfArray.forEach(item => {
                if (item.field_type == "contacts") {
                    const contactObjArray = this.projectDetail.contacts.filter(
                        contactItem => contactItem.id == item.value
                    );
                    this.$set(item, "contactData", contactObjArray[0]);
                }
            });
            if (childObjArray) {
                // loop through all this.projectDetail.customFields
                // and if item.id == childObj.parent_id then add role object as child
                childObjArray.forEach(child => {
                    cfArray.forEach(item => {
                        if (!item.children) {
                            this.$set(item, "children", []);
                        }
                        if (
                            item.id == child.parent_id &&
                            item.field_id == child.field_parent_id &&
                            item.field_type == "contacts" &&
                            child.value_set
                        ) {
                            const valueSet = this.parseValue(child.value_set);
                            if (valueSet == false) {
                                // if we don't check for false... it throws up errors
                            } else {
                                const matchingObject = valueSet.find(
                                    item => item.slug === child.value
                                );
                                item.children.push({
                                    ...matchingObject,
                                    ...child
                                });
                            }
                        }
                    });
                });
            }

            return cfArray;
        }
    },
    methods: {
        parseValue(str) {
            try {
                return JSON.parse(str);
            } catch (e) {
                return false;
            }
        },
        clearFlags() {
            this.flags.forEach(flag => {
                flag.toggleContactSelect = false;
            });
        },
        updateContact(contactData, fieldKey) {
            let payload = {
                currentContactData: contactData,
                currentContactId: contactData.id,
                currentFieldKey: fieldKey,
                currentContactTemplateType: "project",
            };
            this.$store.dispatch("updateEditContactRelatedValues", payload);

            switch (fieldKey) {
                default:
                    this.$bvModal.show("editCfContactModal");
                    break;
            }
        },

        updateCfContact(contactData, children, fieldKey) {
            let ccData = contactData;
            ccData.children = children;
            let payload = {
                currentContactData: ccData,
                currentContactId: contactData.id,
                currentFieldKey: fieldKey,
                currentContactTemplateType: "project",
            };
            this.$store.dispatch("updateEditContactRelatedValues", payload);
            switch (fieldKey) {
                default:
                    this.$bvModal.show("editCfContactModal");
                    break;
            }
        },
        showAddCfContact(fieldKey) {
            if (this.projectDetail.permissions.viewOnly) return;
            this.clearFlags();
            this.resetFlag(fieldKey, true);
            this.$nextTick(() => {
                const refName = `search-${fieldKey}`;
                if (
                    this.$refs[refName] &&
                    this.$refs[refName][0] &&
                    this.$refs[refName][0].$refs &&
                    this.$refs[refName][0].$refs.input
                ) {
                    this.$refs[refName][0].$refs.input.focus();
                }
            });
        },
        createCfContact(newContactName, deliverableId, fieldKey) {
            let payload = {
                newContactName,
                deliverableId,
                fieldKey,
                currentContactTemplateType: "project",
            };
            this.$store.dispatch("updateNewContactRelatedValues", payload);
            this.$bvModal.show("createCfContactModal");
        },
        onCfContactSearch(input) {
            return new Promise((resolve, reject) => {
                input = input == false ? "" : input;
                axios
                    .get(
                        process.env.MIX_API_BASE_URL +
                        "activeContacts?q=" +
                        encodeURI(input)
                    )
                    .then(resp => {
                        let contacts = [];
                        let x = 0;
                        //TODO:: use label of field to create new dept contact
                        contacts.push({
                            id: null,
                            label:
                                "Create new contact <strong>" +
                                input +
                                "</strong>",
                            search: input,
                            deliverablId: this.projectDetail.deliverableId
                        });
                        for (x = 0; x < resp.data.length; x++) {
                            contacts.push(resp.data[x]);
                        }
                        this.$store.commit("setInitialData", {
                            contacts: contacts
                        });
                        resolve(contacts);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        onCfContactSelect(selected) {
            const flagWithToggleTrue = this.flags.find(
                flag => flag.toggleContactSelect
            );
            if (flagWithToggleTrue) {
                // set current selected field type and pass it in api
                this.currentFieldKey = flagWithToggleTrue.field_key;
                if (selected.id == null) {
                    // add new contact..
                    this.newContactId = null;
                    this.createCfContact(
                        selected.search,
                        this.projectDetail.deliverableId,
                        this.currentFieldKey
                    );
                } else {
                    this.newContactId = selected;
                    this.inputAddContact(this.currentFieldKey);
                }
                const refName = `search-${this.currentFieldKey}`;
                if (this.$refs[refName] && this.$refs[refName][0]) {
                    this.$refs[refName][0].value = null;
                }
                this.resetFlag(this.currentFieldKey, false);
            } else {
                console.warn("No flag found with toggleContactSelect true");
            }
        },
        addProjectContact(payload) {
            this.$store.dispatch("addProjectContact", payload);
            this.newContactId = "";
        },

        inputAddContact(field_key) {
            let x = 0;
            let field_id = null;
            for (x = 0; x < this.projectDetail.customFields.length; x++) {
                if (
                    this.projectDetail.customFields[x].field_key ==
                    field_key
                ) {
                    field_id = this.projectDetail.customFields[x].field_id;
                    break;
                }
            }
            this.newContactId.fieldId = field_id;
            switch (field_key) {
                default:
                    this.addProjectContact({
                        contactData: this.newContactId,
                        projectId: this.projectDetail.projectId,
                        currentFieldKey: this.currentFieldKey
                    });
                    break;
            }
        },

        resetFlag(fieldKey, flagValue) {
            const flagIndex = this.flags.findIndex(
                flag => flag.field_key === fieldKey
            );
            if (flagIndex !== -1) {
                this.flags[flagIndex].toggleContactSelect = flagValue;
            }
        },

        setShowFieldFlags() {
            this.flags = this.projectDetail.contactTypeFields;
            const contactCustomFields = _.filter(
                this.projectDetail.projectCustomFields,
                { field_type: "contacts" }
            );
            if (
                Array.isArray(contactCustomFields) &&
                contactCustomFields.length
            ) {
                // array exist, is not empty
                contactCustomFields.forEach(ccField => {
                    // Check the field_key of each object and set the corresponding flag to true
                    const flagIndex = this.flags.findIndex(
                        flag => flag.field_key === ccField.field_key
                    );
                    if (flagIndex !== -1) {
                        this.flags[flagIndex].showField = true;
                    }
                });
            }
        },

        outside() {
            this.addContactFlag = false;
            this.clearFlags();
        }
    },
    watch: {
        projectDetail: {
            handler() {
                this.setShowFieldFlags();
            },
            deep: true,
            immediate: true
        }
    }
};
</script>
